// removed by extract-text-webpack-plugin
module.exports = {"component":"_3Tg2_NJDqzvZ_DkqaFWBP_","branding":"_3eyrgB9fPgLPSfqpjb8E-g","logoUrl":"USGBWs_8VGkXXea3MRsPw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/HeaderBranding.css
// module id = 962
// module chunks = 0